import { FC } from 'react';
import { fabric } from 'fabric';
import { useFabricEditor } from '../../lib/FabricJs';
import { AssetFileType } from '../../../../types/assets.types';
import { placeNearSlideCenter } from '../../utils/placeNearSlideCenter';
import MediaGrid from './media/MediaGrid';
import { useMediaLibrary } from './media/useMediaLibrary';

const ImageWidget: FC = () => {
  const { canvas } = useFabricEditor();
  const library = useMediaLibrary(AssetFileType.Image);

  const onAddImage = (path: string, assetId: string) => {
    fabric.Image.fromURL(path, function (oImg) {
      if (!canvas) return;
      oImg.set('data', { assetId });
      oImg.scaleToWidth(600, true);
      oImg.scaleToHeight(600, true);
      oImg.applyResizeFilters();
      oImg.setControlsVisibility({
        mt: false, // middle top disable
        mb: false, // middle bottom
        ml: false, // middle left
        mr: false, // I think you get it
      });
      placeNearSlideCenter(canvas, oImg);
      canvas.add(oImg);
    });
  };

  return (
    <MediaGrid
      kind="image"
      library={library}
      onPick={(asset) => onAddImage(asset.url, asset._id)}
    />
  );
};

export default ImageWidget;
